import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useTable } from 'react-table'
import { withAuthHeader } from '../../routes/authRequest';
import routes from '../../routes/routes';

const UserReactTableComponent = ({ data: tableData, header }) => {
    // console.log(tableData, header);
    const [events, setEvents] = useState('')

    useEffect(() => {
        withAuthHeader.get(routes.api.locations.getMember)
            .then(res => {
                setEvents(res.data[0].data)
                console.log(res.data[0].data);
            })
            .catch(err => {
                console.log(err);
            })
    }, [])
    const data = React.useMemo(
        () => events || [],
        [events]
    )

    const columns = React.useMemo(
        () => [
            {
                Header: 'member_id',
                accessor: 'member_id', // accessor is the "key" in the data
            },
            {
                Header: 'surname',
                accessor: 'surname',
            },
            {
                Header: 'other_names',
                accessor: 'other_names',
            },
            {
                Header: 'email',
                accessor: 'email',
            },
            {
                Header: 'phone_no',
                accessor: 'phone_no',
            },
            {
                Header: 'address',
                accessor: 'address',
            },
            {
                Header: 'financial_status',
                accessor: 'financial_status',
            },
        ],
        []
    )
    const tableInstance = useTable({ columns, data })

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance


    return (
        // apply the table props
        <div className="table-responsive">


            <table {...getTableProps()} className="table table-hover table-responsive">
                <thead className="thead-dark">
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th
                                    {...column.getHeaderProps()}
                                >
                                    {column.render('Header')}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map(row => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                        >
                                            {cell.render('Cell')}
                                        </td>
                                    )
                                })}
                                <td>
                                    <Link to={
                                        {
                                            pathname: routes.public.editUser,
                                            state: { user: row.original }
                                        }}
                                        class="btn btn-default"
                                    >
                                        Edit
                                </Link>
                                </td>
                                <td>
                                    <Link
                                        to={{
                                            pathname: routes.public.messageMember,
                                            state: { member: row.original }
                                        }}
                                        class="btn btn-success"
                                        onClick={(event) => null}
                                    >
                                        <i className="glyphicon glyphicon-envelope"></i>
                                    </Link>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table >
        </div>
    )
}

export default UserReactTableComponent
